module.exports = __webpack_public_path__ + "img/logo111.fd719b03.png";